// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { Injectable } from '@angular/core';
import moment from 'moment';
import { BehaviorSubject } from 'rxjs';

interface DateRange {
  firstDate: moment.Moment;
  lastDate: moment.Moment;
}

@Injectable({
  providedIn: 'root',
})
export class DateRangeService {
  private dateRangeSource = new BehaviorSubject<DateRange | null>(
    this.loadDateRange('dateRange')
  );
  dateRange$ = this.dateRangeSource.asObservable();

  private reversedDateRangeSource = new BehaviorSubject<DateRange | null>(
    this.loadDateRange('reversedDateRange')
  );

  reversedDateRange$ = this.reversedDateRangeSource.asObservable();

  setDateRange(dateRange: DateRange): void {
    this.dateRangeSource.next(dateRange);
    this.saveDateRange('dateRange', dateRange);
  }

  setReversedDateRange(dateRange: DateRange): void {
    this.reversedDateRangeSource.next(dateRange);
    this.saveDateRange('reversedDateRange', dateRange);
  }

  private loadDateRange(key: string): DateRange | null {
    const storedDateRange = localStorage.getItem(key);
    return storedDateRange ? JSON.parse(storedDateRange) : null;
  }

  private saveDateRange(key: string, dateRange: DateRange): void {
    localStorage.setItem(key, JSON.stringify(dateRange));
  }
}
